// import React from "react";
// import { sedan } from "./data/sedan";
// import VehicleCard from "./VehicleCard";
// import VehicleFullCard from "./VehicleCard";

// export default function Sedan() {
//   return (
// <>


// <section
//         className="breadcrumb-section"
//         style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
//       >
//         <div className="container">
//           <div className="banner-content">
//             <h1>Sedan Cars
//  </h1>
//           </div>
//         </div>
//       </section>
  


//     <div className="vehicle-page">

//       <div className="grid">
//         {/* {sedan.map((v) => (
//           <VehicleCard key={v.id} v={v} />
//         ))} */}


//         {sedan.map((v) => (
//   <div className="full-width-item" key={v.id}>
//     {/* <VehicleCard v={v} /> */}
//     <VehicleFullCard v={v} />
//   </div>
// ))}

//       </div>
//     </div>

// </>
//   );
// }



import React from "react";
import { sedan } from "./data/sedan";
import VehicleFullCard from "./VehicleFullCard";

export default function Sedan() {
  return (
    <>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Sedan Cars</h1>
          </div>
        </div>
      </section>
{/* 
      <div className="vehicle-page">
        <div className="vehicle-list-wrapper">
          {sedan.map((v) => (
            <div className="vehicle-row-single" key={v.id}>
              <VehicleFullCard v={v} />
            </div>
          ))}
        </div>
      </div> */}

<div className="vehicle-page">
  <div className="vehicle-container">
    {sedan.map((v) => (
      <VehicleFullCard key={v.id} v={v} />
    ))}
  </div>
</div>


    </>
  );
}
